import React, { Component } from 'react';
//import { Button } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { TextField, Table, TableCell, Modal, TableBody, Radio, TableHead, TableContainer,  TableRow, Button, Box, Tooltip, Paper, Toolbar, Typography, IconButton, Grid, Badge  } from '@material-ui/core';
import Loader from '../../../loader';
import { connect } from 'react-redux';
import axios from "axios";
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import i18n from '../../../../i18next';
import customStyle from '../../../../Assets/CSS/stylesheet_UHS';
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import Cart from '../../../../Assets/Images/cart.svg'
import {MuiPickersUtilsProvider, KeyboardDatePicker,DatePicker} from '@material-ui/pickers';
import CommonDropFamily from '../CommonPopup/CommonDropFamily';
import CommonDropDwn from '../CommonPopup/CommonDropDwn';
import CommonTable from './CommonTable'
import '../Add-ons/addOnsScreen.css';


const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
      color: '#fa6446',
  },
  tooltip: {
    backgroundColor: '#fa6446',
      border: '1px solid #dadde9',
      fontSize : '12px'
  },
}));

const useStylesBootstrap_otherQuote = makeStyles(theme => ({
    arrow: {
        color: '#4a4b57',
    },
    tooltip: {
        backgroundColor: '#4a4b57',
        border: '1px solid #dadde9',
        fontSize : '12px'
    },
}));


const StyledTableRow = withStyles({
    root: {
        backgroundColor: "#F4F4F4",
        '&.Mui-selected': {
            backgroundColor: "#08C289",
          },
          "&.Mui-selected.MuiTableRow-hover":{
            backgroundColor: "#08C289",
          },
    },
  })(TableRow);


const ProceedButton = withStyles(
    {
        root: {
            backgroundColor: '#0e234d',
            color: '#ffffff',
            fontWeight: "bold",
            '&:hover': {
                backgroundColor: '#420045',
                boxShadow: '0 4px 8px 0 #eae8db, 0 2px 4px 0 #eae8db',
            },
            '&:focus':{
                outline:'none'
            },
            '&:disabled': {
                backgroundColor: '#BDBDBD',
                color: '#ffffff'
            },
        },
    }

)(Button);

const styles = theme => ({
  table: {
    minWidth: 400,
  },
});




class MultiAddons extends Component {
  constructor(props) {
    super(props);
      this.state = {
        clientid: sessionStorage.getItem("CLIENT_ID"),
        subId:  JSON.parse(localStorage.getItem('CurrentLoginUser')).id,
        loaderShow: this.props.loaderShow,
        addonList:[],
        selected: null,
        planSelectedAmount: null,
        selecdPlanID:null,
        appFeeAmount: null,
        data: null,
        listOfCost:[],
        familyList: [],
        selectedFamily:null,
        step: this.props.indexOfMultiAddons,
        arrayOfAddonAmount:[],
        listofAddonSelected:[],
        coreSelectedFamily: null,
        addonSelectedFamily: [],
    };
  }

  componentDidMount() {
   
    // axios.get(process.env.REACT_APP_BASE_URL+"/plan/getAddonList/"+`/${this.state.clientid}`).then((response)=>{
    //   this.setState({addonList: response.data.response}, () =>{
        this.getAddonData(this.props.addon);
        this.getCorePlanDetails();
      // })
    // })
   }


   getAddonData = async (type) =>{
    console.log('this.props.addonSelectedFamily: ', await this.props.addonSelectedFamily[this.props.indexOfMultiAddons]);
    // console.log('this.props.listofAddonSelected: ', await this.props.listofAddonSelected[this.props.indexOfMultiAddons]);
    axios.get(process.env.REACT_APP_BASE_URL+"/plan/getAddonData/"+`${this.state.subId}/${this.state.clientid}/${type}`).then((res)=>{
      this.setState({data: res.data.response, 
        selectedFamily: res.data.response[0].categoryAmountList[0].category
      }, () => {
       
          let listCost= [];
          let familyList =[];
          let addonList=[]
          res.data.response.map((res1) => {
            listCost.push(res1.categoryAmountList[0].amount);
          });
      
          res.data.response.map((res2)=>{
              familyList.push(res2.categoryAmountList[0].category);
          })

          res.data.response.map((res2)=>{
            addonList.push(res2.categoryAmountList[0].planCode);
        })

          this.setState({listOfCost: listCost, familyList: familyList}, () =>{
            axios.get(process.env.REACT_APP_BASE_URL+"/plan/getMemberPlan"+`/${this.state.subId}/${type}`).then((resp)=>{
              // this.setState({loaderShow: false})
              let indexOne=res.data.response.indexOf(res.data.response.filter(x => x.planId === this.props.listofAddonSelected[this.state.step])[0]);
              listCost=[];
              familyList=[];
              addonList=[]
              res.data.response.map((res3, ind) => {
                listCost.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && ind == indexOne) ? this.props.arrayOfAddonAmountBadge[this.props.indexOfMultiAddons] : res3.categoryAmountList && res3.categoryAmountList[0].amount);
                // listCost.push(res.categoryAmountList[0].amount);
              });
              res.data.response.map((res4, ind)=>{
                familyList.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && indexOne == ind) ? this.props.addonSelectedFamily[this.props.indexOfMultiAddons] : res4.categoryAmountList[0].category);
            })
            res.data.response.map((res4, ind)=>{
              addonList.push((this.props.addonSelectedFamily[this.props.indexOfMultiAddons] && indexOne == ind) ? this.props.listofAddonSelected[this.props.indexOfMultiAddons] : res4.categoryAmountList[0].planCode);
          })
              this.setState({selected: indexOne})
              this.setState({listOfCost: listCost, familyList: familyList}, () =>{
              if(resp.data.response){
                // listCost= [];
                // familyList =[];
                let index=res.data.response.indexOf(res.data.response.filter(x => x.planId === resp.data.response.planCode)[0]);
              //   res.data.response.map((res5, ind) => {
              //     listCost.push((this.props.addonSelectedFamily[this.state.step] && ind == index) ? this.props.arrayOfAddonAmountBadge[this.props.indexOfMultiAddons] : res5.categoryAmountList && res5.categoryAmountList[0].amount);
              //     // listCost.push(res.categoryAmountList[0].amount);
              //   });
              //   res.data.response.map((res6, ind)=>{
              //     familyList.push((this.props.addonSelectedFamily[this.state.step] && index == ind) ? this.props.addonSelectedFamily[this.props.indexOfMultiAddons] : res6.categoryAmountList[0].category);
              // })
              this.setState({listOfCost: listCost, familyList: familyList}, () =>{
                let listOfCost = this.state.listOfCost;
                let arrayOfAddonAmount  =  this.props.arrayOfAddonAmountBadge;
                let listofAddonSelected = this.state.listofAddonSelected;
                let addonSelectedFamily = this.props.addonSelectedFamily;
                
                let flagRemoveDepentent = res.data.response[index].categoryAmountList.find(x => x.category === resp.data.response.category) ? true :false;
                
                let family = this.state.familyList;

                
                // family[index] = flagRemoveDepentent ? resp.data.response.category : this.state.data[index].categoryAmountList[0].category;
                // arrayOfAddonAmount[this.state.step] = flagRemoveDepentent ? resp.data.response.amount :  this.state.data[index].categoryAmountList[0].amount;
                listofAddonSelected[this.state.step] = resp.data.response.planCode
                // listOfCost[index] =  arrayOfAddonAmount[this.state.step] ? arrayOfAddonAmount[this.state.step]:  resp.data.response.amount;
                addonSelectedFamily[this.state.step] = flagRemoveDepentent ? resp.data.response.category: res.data.response[index].categoryAmountList[0].category;
                this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
                this.props.setlistofAddonSelected(addonList[indexOne]);
                this.props.setaddonSelectedFamily(family[indexOne]) 
                this.props.setListOfCost(listOfCost[this.state.step]) 
                  this.setState({
                    selectedFamily: flagRemoveDepentent ? resp.data.response.category : res.data.response[index].categoryAmountList[0].category,
                    arrayOfAddonAmount: arrayOfAddonAmount,
                    listofAddonSelected: listofAddonSelected,
                    selected: indexOne >= 0 ? indexOne : index,
                    // listOfCost: listOfCost,
                    familyList: family,

                    addonSelectedFamily: addonSelectedFamily
                  })
                })
              }
            })
            })
          })
         
      })
  })
   }
  getCorePlanDetails = () =>{
    axios.get(process.env.REACT_APP_BASE_URL+"/plan/getMemberPlan"+`/${this.state.subId}/Core`).then((resp)=>{
      if(resp.data.response)
        this.setState({
          planSelectedAmount: resp.data.response.amount,
          appFeeAmount: resp.data.response.appFee,
          selecdPlanID: resp.data.response.planCode,
          coreSelectedFamily: resp.data.response.category
        })
        else
        this.props.backStep();
    })
  }
    handleClick = (index, seletedAddon) => {
      console.log("::::", index, seletedAddon, this.state.familyList, index)
      if(this.state.selected === index){
        let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
        let listofAddonSelected = this.state.listofAddonSelected;
        let addonSelectedFamily = this.state.addonSelectedFamily;
        addonSelectedFamily[this.state.step] = this.state.familyList[index];
        listofAddonSelected[this.state.step]=null;
        arrayOfAddonAmount[this.state.step]=0;
        this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
        this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
        this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
        this.setState({selected: null, arrayOfAddonAmount: arrayOfAddonAmount, listofAddonSelected: listofAddonSelected, addonSelectedFamily: addonSelectedFamily});
      }else{
        let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
        let costList =this.state.listOfCost;
        let listofAddonSelected = this.state.listofAddonSelected;
        listofAddonSelected[this.state.step] = seletedAddon.planId;
        let addonSelectedFamily = this.state.addonSelectedFamily;
        addonSelectedFamily[this.state.step] = this.state.familyList[index];
        arrayOfAddonAmount[this.state.step] = costList[index];
        this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
        this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
        this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
        this.setState({selected: index, arrayOfAddonAmount: arrayOfAddonAmount, listofAddonSelected: listofAddonSelected, addonSelectedFamily: addonSelectedFamily});
      }
    };
    selectedClick = (index, seletedAddon) =>{
      let arrayOfAddonAmount= this.state.arrayOfAddonAmount;
      let costList =this.state.listOfCost;
      let addonSelectedFamily = this.state.addonSelectedFamily;
      addonSelectedFamily[this.state.step] = this.state.familyList[index];
      let listofAddonSelected = this.state.listofAddonSelected;
      listofAddonSelected[this.state.step] = seletedAddon.planId;
      arrayOfAddonAmount[this.state.step] = costList[index];
      this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
      this.props.setlistofAddonSelected(listofAddonSelected[this.state.step]);
      this.props.setaddonSelectedFamily(addonSelectedFamily[this.state.step])
      this.setState({selected: index, arrayOfAddonAmount: arrayOfAddonAmount, listofAddonSelected:listofAddonSelected, addonSelectedFamily: addonSelectedFamily});
    }
    submitAndNextAddon = () =>{

      let obj = {
            subId: this.state.subId,
            planCode: this.state.data[this.state.selected] ? this.state.data[this.state.selected].planId: null,
            amount: this.state.listOfCost[this.state.selected] ? this.state.listOfCost[this.state.selected]: 0,
            appFee: 0,
            category: this.state.familyList[this.state.selected] ? this.state.familyList[this.state.selected]:  null,
            planType:this.state.addonList[this.state.step]
        }
       
       this.setState({loaderShow: true})
        axios.post(process.env.REACT_APP_BASE_URL+"/plan/saveMemberPlan", obj).then((res)=>{
            this.setState({selected: null, step: this.state.step+1, listOfCost: [], familyList: []}, ()=>{
              this.getAddonData(this.state.addonList[this.state.step]);
            })
        })
           
    }
    SubmitPlanRequest = () =>{
      let obj = {
        subId: this.state.subId,
        planCode: this.state.data[this.state.selected] ? this.state.data[this.state.selected].planId: null,
        amount: this.state.listOfCost[this.state.selected] ? this.state.listOfCost[this.state.selected]: 0,
        appFee: 0,
        category: this.state.familyList[this.state.selected] ? this.state.familyList[this.state.selected]:  null,
        planType:this.state.addonList[this.state.step]
      }
        this.setState({loaderShow: true})
  
         

            this.setState({loaderShow: true})
            axios.post(process.env.REACT_APP_BASE_URL+"/plan/saveMemberPlan", obj).then((res)=>{
                this.setState({selected: null, listOfCost: [], familyList: []}, ()=>{
                  this.props.onClick();
                  this.setState({loaderShow: false})
                })
            }).catch(err=>{
                  console.log(err);
                  this.setState({loaderShow: false})
              })
   
    }
    backScreen = () =>{
      this.setState({loaderShow: true})
      let arrayOfAddonAmount = this.state.arrayOfAddonAmount;
      let listofAddonSelected =this.state.listofAddonSelected;
      listofAddonSelected.pop();
      arrayOfAddonAmount.pop();  
          this.setState({selected: null, step: this.state.step-1, arrayOfAddonAmount: arrayOfAddonAmount, listofAddonSelected: listofAddonSelected, listOfCost: [], familyList: []}, ()=>{
            this.getAddonData(this.state.addonList[this.state.step]);
          })
    }
    render() {
      var totalAmountOfAddon = 0;
      this.props.arrayOfAddonAmount.length> 0 && this.props.arrayOfAddonAmount.map(val=>{
        totalAmountOfAddon+=val?val:0;
      })
    if(this.state.data)
    return (
      <div style={{}}>
        {this.state.loaderShow ? <Loader/> : ''}
     


    
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              key={this.props.key}
              // size={dense ? "small" : "medium"}
            >
              <TableBody>
                {this.state.data.map((row, index) => {
                  const isItemSelected = index === this.state.selected;
                  console.log(`${this.state.selected} =======>selected ${index} `);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <StyledTableRow
                      hover
                      role="radio"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.planInfo}
                      selected={isItemSelected}
                     
                    >
                      <TableCell padding="checkbox"  style={{paddingTop:0}}  onClick={(event) => this.handleClick(index, this.state.data[index])}>
                        <Radio
                          checked={isItemSelected}
                          value={row.planInfo}
                          style={{
                            color: "#162242"
                          }}
                          name="radio-buttons"
                          className="radio-buttons"
                          inputProps={{ "aria-label": "A" }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        style={{paddingTop:0, paddingBottom: 0}}
                        onClick={(event) => this.handleClick(index, this.state.data[index])}
                      >
                        Add <b>{row.planId}</b>
                      </TableCell>

                      <TableCell align="left" style={{ width: "10%", paddingTop:0, paddingBottom: 0 }}  onClick={(event) => this.handleClick(index, this.state.data[index])}>
                      </TableCell>

                      <TableCell align="left" style={{ width: "10%", paddingTop:0, paddingBottom: 0  }}  onClick={(event) => this.selectedClick(index, this.state.data[index])}>
                        
                        {this.state.familyList[index] && <CommonDropFamily
                          value={row.categoryAmountList}
                          index={index}
                          selectedIndex={this.state.selected === index}
                          selectedFamily={this.state.familyList[index]}
                          selectCost={(value, ind) => {
                            let list = this.state.listOfCost;
                            let familyList = this.state.familyList;
                            let arrayOfAddonAmount = this.state.arrayOfAddonAmount;
                            let addonSelectedFamily = [];

                            let amount = row.categoryAmountList.filter(
                              (x) => x.category === value
                            )[0].amount;
                            familyList[ind] = value;
                            list[ind] = amount;
                            arrayOfAddonAmount[this.state.step] = amount;
                            addonSelectedFamily[this.state.step] = value;
                            this.props.setArrayOfAddonAmount(arrayOfAddonAmount[this.state.step]);
                            this.props.setArrayOfAddonAmountBadge(arrayOfAddonAmount[this.state.step]);
                            this.props.setListOfCost(list)
                            this.setState({selectedFamily: value, listOfCost: list, familyList: familyList, arrayOfAddonAmount: arrayOfAddonAmount, addonSelectedFamily: addonSelectedFamily});
                          }}
                        />}
                      </TableCell>
                      <TableCell align="right" style={{ width: "10%", paddingTop:0, paddingBottom: 0, fontFamily: "Lato", fontSize: "15px", color:"rgba(0, 0, 0, 0.6)"  }}
                       onClick={(event) => this.handleClick(index, this.state.data[index])}
                      >
                        <span
                          className="cost-per-month"
                          style={{
                            fontWeight: 700,
                            fontSize: "25px",
                            color: index===this.state.selected?"#fff":"#00c389"
                          }}
                        >
                          ${this.state.listOfCost[index] ? Number(this.state.listOfCost[index]).toFixed(2): 0}
                        </span>
                        /MONTH
                      </TableCell>
                      <TableCell align="right" style={{ width: "10%", paddingTop:0, paddingBottom: 0  }}>
    
                        <IconButton onClick={() => window.open(row.link)}>
                          <span  style={{ fontSize: 13, fontWeight: "bold", color: isItemSelected? "#0e234d" : "#009cde", width:100 }}>VIEW DETAILS</span>
                          </IconButton>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
      </div>
    )
    else return <> <Loader/> </>
  }
}

const mapStateToProps = state => {
  return {
    subId: state.subId
  };
}

export default withStyles(styles)(connect(mapStateToProps)(MultiAddons));






